export default "/static/dashboard/build/app/img/v2/f0d807cbbc8dc620b5a97b6fcd50fd4f.png";